// extracted by mini-css-extract-plugin
module.exports = {"container":"place__styles__container--1Vmw2PLS","medal":"place__styles__medal--3g9B5W5q","value":"place__styles__value--2UQbJ9Fc"};